import React, { useState } from 'react';
import filter from './img/filter.svg';
import tia from './img/tia.png';
import trophy from './img/trophy.svg';
import line from './img/line.svg';
import { StudyGuideDiagnostic } from './study-guide-diagnostic/study-guide-diagnostic';
import { StudyGuideLesson } from './study-guide-lesson';
import { StudyGuideQuiz } from './study-guide-quiz';
import { StudyGuideMyGuide } from './study-guide-my-guide';
// import {StudyGuideMonitoring} from './study-guide-monitoring';
import { StudyGuideModalLegend } from './study-guide-modal-legend';
import { DashboardContent } from '@/layouts/dashboard';
import {
  GuideAbout,
  GuideAboutBg,
  GuideAboutBody,
  GuideAboutHeader,
  GuideAboutLine,
  GuideAboutSection,
  GuideAboutSectionBody,
  GuideAboutSectionDescription,
  GuideAboutSectionHeader,
  GuideAboutSectionImg,
  GuideAboutSectionList,
  GuideAboutSectionTitle,
  GuideAboutTitle
} from '@/components/custom/guide';
import { Button } from '@/components/ui/button';
import { Dialog, DialogTrigger } from '@/components/ui/dialog';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import { PlayfulCard } from '@/components/custom/playful-card';
import { TiaBanner } from '@/components/custom/tia-banner';
import tiaInfo from '@/assets/images/tia/TIA-INFO.png';

export function StudyGuidePanorama(props) {
  const { uri } = props;
  const playful = usePlayfulStudent();

  const [showModal, setShowModal] = useState(false);

  const breadcrumbs = {
    title: 'Aprendizado Dinâmico',
    nav: [
      {
        route: '/guia-de-estudos',
        name: 'Guia de estudos',
        isActive: false
      },
      {
        route: uri,
        name: 'Como o Guia funciona',
        isActive: true
      }
    ]
  };

  if (playful) {
    return (
      <DashboardContent breadcrumbs={breadcrumbs}>
        <div className="w-full">
          <TiaBanner
            className="mb-6 md:mt-16"
            image={tiaInfo}
            imageHeight={160}
            imageOffset={140}
            bubbleMaxWidth={480}
            text="Toda aula, quiz e interação sua no Guia me ajuda a montar sua trilha ideal. Olha como funciona! 🧠"
          />

          <div className="mb-4 flex justify-end">
            <Dialog>
              <DialogTrigger asChild>
                <button
                  type="button"
                  className="relative overflow-hidden rounded-full px-5 py-2 text-sm font-extrabold text-white transition-transform active:scale-[0.97]"
                  style={{ background: 'var(--gradient-btn-continue)', boxShadow: '0 3px 0 var(--color-mission-dark)' }}
                >
                  <span
                    className="pointer-events-none absolute inset-x-0 top-0 h-1/2 rounded-t-full"
                    style={{ background: 'linear-gradient(180deg, rgba(255,255,255,0.2) 0%, transparent 100%)' }}
                  />
                  Legenda
                </button>
              </DialogTrigger>

              <StudyGuideModalLegend
                show={showModal}
                onClose={() => setShowModal(false)}
              />
            </Dialog>
          </div>

          <div className="flex flex-col gap-4">
            <PlayfulCard
              className="p-6"
              style={{ background: 'var(--color-bg-lilac)' }}
            >
              <div className="mb-3 flex items-center gap-3">
                <img
                  src={filter}
                  alt="filtro"
                  className="h-10 w-10"
                />
                <p
                  className="mb-0 text-base font-extrabold"
                  style={{ color: '#222731' }}
                >
                  Todas as suas interações nos são constantemente coletadas pela nossa Tecnologia de Inteligência Artificial
                </p>
              </div>
              <p className="mb-4 text-sm text-neutral-600">Todas as aulas que você iniciou e quizzes que respondeu são levados em consideração para personalizar o seu guia.</p>
              <div className="grid gap-4 sm:grid-cols-2">
                <StudyGuideLesson />
                <StudyGuideQuiz />
              </div>
            </PlayfulCard>

            <PlayfulCard
              className="p-6"
              style={{ background: 'var(--color-bg-teal)' }}
            >
              <div className="mb-3 flex items-center gap-3">
                <img
                  src={tia}
                  alt="T.I.A"
                  className="h-10 w-10 rounded-full"
                />
                <p
                  className="mb-0 text-base font-extrabold"
                  style={{ color: '#222731' }}
                >
                  A T.I.A, nossa IA, cuidadosamente analisa e organiza suas preferências para criar o Guia de Estudos ideal para você, então...
                </p>
              </div>
              <p className="mb-4 text-sm text-neutral-600">As interações no seu próprio Guia de Estudos e as monitorias que você participa também são essenciais para a T.I.A entender como você aprende</p>
              <div className="flex flex-col gap-4">
                <StudyGuideMyGuide />
                {/* <StudyGuideMonitoring /> */}
              </div>
            </PlayfulCard>

            <PlayfulCard
              className="p-6"
              style={{ background: 'var(--color-bg-mission-soft)' }}
            >
              <div className="mb-3 flex items-center gap-3">
                <img
                  src={trophy}
                  alt="troféu"
                  className="h-10 w-10"
                />
                <p
                  className="mb-0 text-base font-extrabold"
                  style={{ color: '#222731' }}
                >
                  ... traçamos uma trilha com conteúdos personalizados e atualizados semanalmente para te auxiliar.
                </p>
              </div>
              <p className="mb-4 text-sm text-neutral-600">Nas provas diagnósticas, você mostra suas forças e seus pontos de melhoria para que a T.I.A possa ajustar seu Guia às suas necessidades.</p>
              <div className="grid gap-4">
                <StudyGuideDiagnostic />
              </div>
            </PlayfulCard>
          </div>
        </div>
      </DashboardContent>
    );
  }

  return (
    <DashboardContent breadcrumbs={breadcrumbs}>
      <GuideAbout>
        <GuideAboutHeader>
          <GuideAboutTitle>Como seus interesses influenciam o seu Guia de Estudos?</GuideAboutTitle>

          <Dialog>
            <DialogTrigger asChild>
              <Button variant="outline">Legenda</Button>
            </DialogTrigger>

            <StudyGuideModalLegend
              show={showModal}
              onClose={() => setShowModal(false)}
            />
          </Dialog>
        </GuideAboutHeader>

        <GuideAboutBody>
          <GuideAboutBg>
            <GuideAboutLine
              src={line}
              alt="linha"
            />
          </GuideAboutBg>

          <GuideAboutSection>
            <GuideAboutSectionHeader>
              <GuideAboutSectionImg
                src={filter}
                alt="filtro"
              />
              <GuideAboutSectionTitle>Todas as suas interações nos são constantemente coletadas pela nossa Tecnologia de Inteligência Artificial</GuideAboutSectionTitle>
            </GuideAboutSectionHeader>

            <GuideAboutSectionBody>
              <GuideAboutSectionDescription>Todas as aulas que você iniciou e quizzes que respondeu são levados em consideração para personalizar o seu guia.</GuideAboutSectionDescription>
              <GuideAboutSectionList>
                <StudyGuideLesson />
                <StudyGuideQuiz />
              </GuideAboutSectionList>
            </GuideAboutSectionBody>
          </GuideAboutSection>

          <GuideAboutSection>
            <GuideAboutSectionHeader>
              <GuideAboutSectionImg
                src={tia}
                alt="T.I.A"
              />
              <GuideAboutSectionTitle>A T.I.A, nossa IA, cuidadosamente analisa e organiza suas preferências para criar o Guia de Estudos ideal para você, então...</GuideAboutSectionTitle>
            </GuideAboutSectionHeader>

            <GuideAboutSectionBody>
              <GuideAboutSectionDescription>As interações no seu próprio Guia de Estudos e as monitorias que você participa também são essenciais para a T.I.A entender como você aprende</GuideAboutSectionDescription>
              <GuideAboutSectionList>
                <StudyGuideMyGuide />
                {/* <StudyGuideMonitoring /> */}
              </GuideAboutSectionList>
            </GuideAboutSectionBody>
          </GuideAboutSection>

          <GuideAboutSection>
            <GuideAboutSectionHeader>
              <GuideAboutSectionImg
                src={trophy}
                alt="troféu"
              />
              <GuideAboutSectionTitle>... traçamos uma trilha com conteúdos personalizados e atualizados semanalmente para te auxiliar.</GuideAboutSectionTitle>
            </GuideAboutSectionHeader>

            <GuideAboutSectionBody>
              <GuideAboutSectionDescription>Nas provas diagnósticas, você mostra suas forças e seus pontos de melhoria para que a T.I.A possa ajustar seu Guia às suas necessidades.</GuideAboutSectionDescription>
              <GuideAboutSectionList>
                <StudyGuideDiagnostic />
              </GuideAboutSectionList>
            </GuideAboutSectionBody>
          </GuideAboutSection>
        </GuideAboutBody>
      </GuideAbout>
    </DashboardContent>
  );
}
